import type { IMasterDataRetailerRepository } from "@src/domain/repositories/masterData";
import type { GetMasterDataRetailersDTO } from "@src/domain/dto/masterData";

export class GetMasterDataRetailersUseCase {
  private readonly repository: IMasterDataRetailerRepository;

  constructor(repository: IMasterDataRetailerRepository) {
    this.repository = repository;
  }

  execute(params: GetMasterDataRetailersDTO) {
    return this.repository.getRetailers(params);
  }
}
